// Client-side public surface: what other modules may use.

import { lazyView } from "@/platform/client";

export const DataPage = lazyView(() => import("./ui/DataPage.js").then((m) => m.DataPage));
export { formLabel, recordTypeLabel } from "./ui/imports/labels.js";
